import * as React from "react";

import { ZAttrValue } from "../ZAttrValue";
import { ZAttrViewLongText } from "./ZAttrViewComponent";

type PropsAttrViewLongText = {
  params: ZAttrViewLongText;
  value: ZAttrValue;
};

export const AttrViewLongText: React.FC<PropsAttrViewLongText> = ({
  value,
  params,
}) => {
  const { maxHeight } = params;
  const text = value.type === "string" ? value.value || "" : "";
  return (
    <div style={{ maxHeight, overflow: "hidden" }} title={text}>
      {text}
    </div>
  );
};
